import React from "react";
import { Typography } from "@material-ui/core";
import { useStyles } from "styling/mainStyles";

const PrivacyText = () => {
  const classes = useStyles();

  return (
    <div className={classes.infoContent}>
      <p>
        <b>Last update: Dec 30, 2020</b>
      </p>

      <p>
        The My Daily Budget mobile app is free and is being supported solely
        though showing ads.
      </p>

      <p>
        This page aims to inform the users about gathering, using and revealing
        of personal information by the app.
      </p>

      <p>
        If you decide to use this app, you have to agree to the gathering and
        using of personal information outlined below. The personal information
        used by this app is used only to conduct and improve its service. Your
        personal information won't be shared with anyone else, but in the cases
        outlined within this privacy policy.
      </p>

      <Typography variant="h5">
        Gathering and usage of personal information
      </Typography>

      <p>
        This mobile application uses the Facebook Login service to identify and
        sign in its users. The information that is kept from that service is{" "}
        <b>email address</b> and <b>facebook id</b>, which are provided by
        Facebook upon the user's authorization. This data is used only to create
        the user's account and to sign the user in after that. This data is not
        provided to third parties, nor it is used for marketing.
      </p>

      <p>
        Every user with an existing account can delete their own data from the
        app's server at any given time. For more information on how to do this,
        please visit the{" "}
        <a href="https://mydailybudget.com/data-deletion">data deletion</a>{" "}
        section.
      </p>

      <p>
        This mobile application also uses the following third party services,
        which may gather personal information too.
      </p>

      <p>
        For more information about what information is gathered by each of them,
        you can visit their privacy policy sections:
      </p>

      <ul>
        <li>
          <a
            href="https://www.google.com/policies/privacy/"
            target="_blank"
            rel="noopener"
            rel="noreferrer"
          >
            Google Play Services
          </a>
        </li>
        <li>
          <a
            href="https://support.google.com/admob/answer/6128543?hl=en"
            target="_blank"
            rel="noopener"
            rel="noreferrer"
          >
            Google AdMob
          </a>
        </li>
        {/* <li>
          <a
            href="https://firebase.google.com/policies/analytics"
            target="_blank"
          >
            Firebase Analytics
          </a>
        </li> */}
      </ul>

      <p>
        We also want to inform you, that any time you use the application, in a
        case of software malfunction, information is gathered via third party
        services on your device, called Log Data. This information might include
        IP address of the device, the name of the device, the os version of the
        device, the configuration of the device while using the app, time and
        date of the event and other statistics.
      </p>

      <Typography variant="h5">Cookies</Typography>

      <p>
        Cookes are files with small quantity of data, which are usually used as
        anonymous unique identificators. They are sent to your browser from the
        websites visited by you and are stored on your device.
      </p>

      <p>
        This app does not use cookies, but it is that the third party services
        this application is using are using cookies.
      </p>

      {/* <h2>Връзки към други сайтове</h2>

      <p>
        Тази услуга може да съдържа връзки към други сайтове, както и външни
        връзки към радио стриймове. Ние нямаме контол върху съдържанието на тези
        сайтове и стриймове и не носим отговорност при евентуално нарушение на
        авторски права или ползване на вулгарен език, както и пропвядване на
        насилие от тяхна страна.
      </p> */}

      <Typography variant="h5">Chidren privacy policy</Typography>

      <p>
        This mobile application is not aimed or intended for use to people under
        the age of 13.
      </p>

      <Typography variant="h5">Changes in this privacy policy</Typography>

      <p>
        Occasional updates to this privacy policy are possible. If there is an
        update that concerns your privacy, you will notified be via the app
        after they are published on this page.
      </p>

      <Typography variant="h5">Contact</Typography>

      <p>For further questions or concerns: admin[at]mydailybudget[dot]com</p>
    </div>
  );
};

export default PrivacyText;
